import { render, staticRenderFns } from "./Payeh.vue?vue&type=template&id=71220352"
import script from "./Payeh.vue?vue&type=script&lang=js"
export * from "./Payeh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports